{
  "pages": {
    "InvoiceDetail": {
      "send": "Send",
      "download": "Download",
      "edit": "Edit",
      "print": "Print",
      "archive": "Archive",
      "delete": "Delete",
      "invoice": "INVOICE",
      "attrs": {
        "pomelo": "Pomelo"
      },
      "singapore": "Singapore",
      "bill_to": "Bill To",
      "issue_date": "Issue Date",
      "due_date": "Due Date",
      "paid_date": "Paid Date",
      "description": "Description",
      "qty": "Qty",
      "unit_price": "Unit Price",
      "total": "Total",
      "usd": "MVR",
      "subtotal": "Subtotal",
      "discount": "Discount",
      "usd_2": "- MVR",
      "tax": "Tax",
      "notes": "Notes",
      "mark_as_paid": "Mark as Paid",
      "confirm_that_this_invoice_has_been": "Confirm that this invoice has been paid",
      "cancel_invoice": "Cancel Invoice",
      "this_action_cannot_be_undone": "This action cannot be undone"
    },
    "InvoiceForm": {
      "invoice_details": "Invoice Details",
      "invoice_number": "Invoice Number",
      "attrs": {
        "autogenerated_if_left_empty": "Auto-generated if left empty",
        "brief_description_of_the_invoice": "Brief description of the invoice",
        "search_or_enter_customer_name": "Search or enter customer name...",
        "customerexamplecom": "customer@example.com",
        "66_xx_xxx_xxxx": "+66 XX XXX XXXX",
        "item_description": "Item description",
        "additional_notes_or_payment_terms": "Additional notes or payment terms..."
      },
      "status": "Status",
      "customer_information": "Customer Information",
      "customer_name": "Customer Name",
      "email": "Email",
      "phone": "Phone",
      "invoice_items": "Invoice Items",
      "add_item": "Add item",
      "cancel": "Cancel",
      "save_as_draft": "Save as Draft"
    },
    "Invoices": {
      "invoices": "Invoices",
      "add_invoice": "Add invoice",
      "total_invoices": "Total Invoices",
      "all_time": "All time",
      "total_amount": "Total Amount",
      "across": "Across",
      "invoices_2": "invoices",
      "paid": "Paid",
      "overdue": "Overdue",
      "attrs": {
        "search_invoices": "Search invoices..."
      },
      "show_archived": "Show archived",
      "no_invoices_found_matching_your_criteria": "No invoices found matching your criteria.",
      "due_on": "Due on",
      "details": "Details",
      "send_email": "Send email",
      "download_pdf": "Download PDF"
    }
  }
}
